import List from 'list.js';

export function list() {
  const list = document.querySelector('.index-container');
  if(list) {
    const listContainer = new List(list, { 
      valueNames: [
        { name: 'title', attr: 'data-name' },
        { name: 'category', attr: 'data-name' },
        { name: 'date', attr: 'data-name' }
      ]
    });

    // listContainer.sort('title', { order: "asc" }); 
  }
}